import { render, staticRenderFns } from "./FilterPopoverTagSearch.vue?vue&type=template&id=844d1e28&scoped=true&"
import script from "./FilterPopoverTagSearch.vue?vue&type=script&lang=js&"
export * from "./FilterPopoverTagSearch.vue?vue&type=script&lang=js&"
import style0 from "./FilterPopoverTagSearch.vue?vue&type=style&index=0&id=844d1e28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "844d1e28",
  null
  
)

export default component.exports